import { AUTHORIZATION_COOKIE, __DEV__ } from "./constants";
import * as cmFun from "./commonFunction";

const getCookie = function (cname) {
  return localStorage.getItem(cname);
};

const setCookie = function (cname, cvalue) {
  localStorage.setItem(cname, cvalue);
};

const deleteCookie = function (name, path, domain) {
  localStorage.removeItem(name);
};

const checkCookie = function (Authorization) {
  try {
    if (cmFun.isEmpty(Authorization)) {
      return false;
    } else {
      let tokenDecode = cmFun.parseJwt(Authorization.access_token);
      let now = new Date().getTime();
      let { exp } = tokenDecode;
      let checkExpiryDate = exp * 10000 > now;
      if (cmFun.isEmpty(Authorization.access_token) || !checkExpiryDate) {
        deleteCookie(AUTHORIZATION_COOKIE);
        return false;
      }
      return true;
    }
  } catch (e) {
    deleteCookie(AUTHORIZATION_COOKIE);
    return false;
  }
};

/**
 * Lưu vào localStorage với thời hạn (tính bằng phút)
 */
const setItemWithExpiry = (key, value, minutes = 5) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + minutes * 60 * 1000, // phút → ms
  };
  localStorage.setItem(key, JSON.stringify(item));
};

/**
 * Lấy giá trị trong localStorage, tự kiểm tra hạn
 */
const getItemWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);
    const now = new Date();

    // Nếu đã hết hạn → xoá luôn và trả null
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch {
    return null;
  }
};

/**
 * Xoá thủ công
 */
const removeItem = (key) => {
  localStorage.removeItem(key);
};

export {
  setCookie,
  getCookie,
  deleteCookie,
  checkCookie,
  setItemWithExpiry,
  getItemWithExpiry,
  removeItem,
};
